<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <AutoComplete
        v-model="searchSchool"
        :value="searchSchool"
        key-value="id"
        key-name="fullname"
        enable-chips
        enable-clearable
        enable-autofocus
        :items="schools"
        :label="$t('fields.school')"
        @search="searchSchools"
        @input="fetchSchoolsIfExist"
        @clear="deleteSelectedSchools"
        :delay="2000"
        :errors="errors"
        :key="reloadAutocomplete"
        :disabled="loading"
      >
      </AutoComplete>
      </v-flex>

      <v-flex xs3 class="mr-2 mt-3">
        <v-select
          :items="codes"
          v-model="schoolCodeId"
          item-text="name"
          item-value="id"
          :label="$t('fields.code')"
          :error-messages="errors"
          @change="fetchTeachers(1)"
          :disabled="!codes.length"
          multiple
        >
        </v-select>
      </v-flex>

      <v-flex xs3 class="mr-2 mt-3">
        <v-select
          v-model="schoolLocationId"
          @change="fetchTeachers(1)"
          item-value="id"
          :items="locations"
          :label="$t('fields.locations')"
          :error-messages="errors"
          multiple
        >
          <template v-slot:selection="{ item }">
              {{ item.options.branch_code }} {{ item.city }} {{ item.street }}
          </template>

          <template v-slot:item="{ item }">
              {{ item.options.branch_code }} {{ item.city }} {{ item.street }}
          </template>
        </v-select>
      </v-flex>

      <v-flex xs3 class="mr-2 mt-3">
        <SchoolSubjectSelect
          v-model="subjectId"
          :error-messages="errors"
          @input="fetchTeachers(1)"
          multiple
          :disabled="filters.schoolId <= 0"
          :school-id="filters.schoolId"
          :key="filters.schoolId"
        >
        </SchoolSubjectSelect>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        @click="exportData()"
        dark
        class="mb-2"
        v-if="Object.keys(school).length && can('export teachers')"
      >{{ $t("EXPORT") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <SchoolCommonInfo
          v-if="Object.keys(school).length"
          :data="school"
          :id="school.id"
        >
        </SchoolCommonInfo>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
     <v-data-table
              :headers="headers"
              :items="items"
              :server-items-length="totalItems"
              :no-data-text="$t('NO_DATA')"
              :no-results-text="$t('NO_DATA')"
              hide-default-footer
              :options.sync="pagination"
              :loading="loading"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              item-key="id"
              show-expand
              class="elevation-1"
              :item-class="itemRowBackground"
            >
              <template v-slot:[`item.teacher_fullname`]="{ item }">
                  <span >
                    {{ item.teacher.fullname }}
                  </span>
              </template>

              <template v-slot:[`item.classes`]="{ item }">
                   <span
                      v-if="item.school.options && item.school.options.classes"
                    >
                      {{ item.school.options.classes }}
                   </span>
              </template>

              <template v-slot:[`item.school_name`]="{ item }">
                  <span >{{ item.school.name }}</span>
              </template>

              <template v-slot:[`item.phone`]="{ item }">
                  <span
                    v-if="item.teacher.address && item.teacher.address.phone"
                  >
                    {{ item.teacher.address.phone }}
                  </span>
              </template>

              <template v-slot:[`item.email`]="{ item }">
                  <span
                    v-if="item.teacher.address && item.teacher.address.email"
                  >
                    {{ item.teacher.address.email }}
                  </span>
              </template>

              <template v-slot:[`item.address`]="{ item }">
                  <span
                    v-if="item.teacher.address &&  item.teacher.address.street"
                  >
                    {{ item.teacher.address.street }}
                  </span>
              </template>

              <template v-slot:[`item.note`]="{ item }">
                   <span
                      v-if="item.teacher.options && item.teacher.options.notice_invisible"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small scolor="primary" v-bind="attrs" v-on="on">
                            N
                          </v-btn>
                        </template>
                        <span>{{item.teacher.options.notice_invisible}}</span>
                      </v-tooltip>
                   </span>
              </template>

              <template v-slot:[`item.subject_name`]="{ item }">
                  <span >{{ item.subject.name }}</span>
              </template>

              <template v-slot:[`item.whatsapp_flag`]="{ item }">
                    <v-icon v-if="item.teacher.options && item.teacher.options.properties && item.teacher.options.properties.whatsapp">done</v-icon>
                    <v-icon v-else>cancel</v-icon>
              </template>

              <template v-slot:[`item.books_counter`]="{ item }">
                <v-badge v-if="item.campaign.counter" :content="item.campaign.counter"></v-badge>
              </template>

              <template v-slot:[`item.platform`]="{ item }">
                    <span
                      v-if="item.teacher.options && item.teacher.options.properties
                      && item.teacher.options.properties.platform"
                    >
                      <span v-for="platform in item.teacher.options.properties.platform"
                        :key="platform"
                      >
                        {{ platform }}
                      </span>
                    </span>
              </template>
              <template v-slot:[`item.actions_edit`]="{ item }">
                <v-layout wrap>
                <v-flex>
                <BtnAddEditTeacher
                  :icon="true"
                  :tooltip="true"
                  :tooltipLabel="$t('EDIT')"
                  :id="item.teacher.id"
                  :color="item.school.counter > 1 ? 'white': 'blue'"
                  v-if="can('edit teachers')"
                  @actionend="fetchTeachers(pagination.page)"
                  :return-url="
                    encodeURIComponent(
                      `${$router.currentRoute.path}?id=${school.id}&schoolCodeId[]=${getSchoolCodeSelected}&subjectId[]=${getSubjectIdsSelected}`)
                  "
                >
                  <v-icon>edit</v-icon>
                </BtnAddEditTeacher>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      v-if="can('edit teachers')"
                      @click="showClassesModal(item)"
                    >
                      <v-icon>class</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('CHANGE_CLASSES') }}</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="red"
                      v-bind="attrs"
                      v-on="on"
                      v-if="can('edit teachers')"
                      @click="setToBox(item.teacher.id)"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('box')}}</span>
                </v-tooltip>
                </v-flex>
                </v-layout>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                    <v-layout wrap>
                      <v-flex>
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                :color="item.school.counter > 1 ? 'white' : 'blue'"
                                v-bind="attrs"
                                v-on="on"
                                v-if="can('edit teachers')"
                                :disabled="!currentUser.user.is_propagandist"
                                @click="showCampaignModal(item.teacher.id)"
                              >
                                <v-icon>menu_book</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('NEW_ESSAY')}}</span>
                          </v-tooltip>
                      </v-flex>
                    </v-layout>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <CampaignTeacherDetailTable
                    :teacher-id="item.teacher.id"
                    :key="item.teacher.id"
                  >
                  </CampaignTeacherDetailTable>
                </td>
              </template>
      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        :per-page-options="[10, 20, 40, 60, 100, 150, 200]"
        @change="fetchTeachers"
      />
      </v-col>
    </v-row>
  </div>
  </v-flex>
</template>
<script>

  import { mapActions, mapGetters } from 'vuex';

  import { campaignsService } from '../../utils/services/campaigns.service';
  import { schoolsService } from '../../utils/services/schools.service';
  import { schoolsLocationsService } from '../../utils/services/schoolsLocations.service';
  import { teachersService } from '../../utils/services/teachers.service';
  import { teachersSchoolsService } from '../../utils/services/teachersSchools.service';
  import { TeacherContactTypes } from '../../utils/constants/teacher-contact-constant';
  import AutoComplete from '../../components/shared/Inputs/AutoComplete';
  import CampaignTeacherModal from '../../components/modals/Campaigns/CampaignTeacherModal';
  import SchoolTeacherModal from '../../components/modals/Teachers/SchoolTeacherModal';
  import CampaignTeacherDetailTable from '../../components/app/Campaigns/CampaignTeacherDetailTable';
  import { schoolsCodesService } from '../../utils/services/schoolsCodes.service';
  import SchoolCommonInfo from '../../components/app/Schools/SchoolCommonInfo.vue';
  import BtnAddEditTeacher from '../../components/buttonsForms/BtnAddEditTeacher.vue';
  import SchoolSubjectSelect from '../../components/shared/Vselects/SchoolSubjectSelect.vue';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'CampaignSchoolResult',
    components: {
      AutoComplete,
      SchoolCommonInfo,
      CampaignTeacherDetailTable,
      BtnAddEditTeacher,
      SchoolSubjectSelect,
      Paginator,
    },
    data() {
      return {
        TeacherContactTypes,
        loading: false,
        expanded: [],
        singleExpand: true,
        items: [],
        codes: [],
        subjects: [],
        schools: [],
        locations: [],
        totalItems: 0,
        searchSchool: null,
        schoolCodeId: [],
        subjectId: [],
        schoolLocationId: [],
        school: {},
        reloadAutocomplete: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['teacher_surname'],
        },
        headers: [
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
          { text: this.$t('fields.teacher'), value: 'teacher_fullname' },
          { text: this.$t('fields.school'), value: 'school_name' },
          { text: this.$t('fields.subject'), value: 'subject_name' },
          { text: this.$t('fields.classes'), value: 'classes', sortable: false },
          { text: this.$t('fields.phone'), value: 'phone', sortable: false },
          { text: this.$t('fields.email'), value: 'email', sortable: false },
          { text: this.$t('fields.address'), value: 'address', sortable: false },
          { text: this.$t('fields.whatsapp'), value: 'whatsapp_flag', sortable: false },
          { text: this.$t('fields.note'), value: 'note', sortable: false },
          { text: this.$t('fields.platform'), value: 'platform', sortable: false },
          { text: this.$t('fields.book'), value: 'books_counter', sortable: false },
          { text: '', value: 'actions_edit', sortable: false, align: 'center' },
          { text: '', value: 'data-table-expand' },
        ],
        filters: {
          searchSchools: null,
          schoolId: 0,
        },
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      requestFilters() {
        const filters = {
          schoolCodeId: this.schoolCodeId,
          subjectId: this.subjectId,
          schoolLocationId: this.schoolLocationId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

      getSchoolCodeSelected() {
        return this.schoolCodeId.filter((x) => x > 0);
      },

      getSubjectIdsSelected() {
        return this.subjectId.filter((x) => x > 0);
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      itemRowBackground(item) {
        return item.school.counter > 1 ? 'blue' : '';
      },
      exportData() {
        if (this.school.id) {
          this.loading = true;
          schoolsService.teachersExport(this.school.id, {
            filters: this.requestFilters,
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'teachers.csv');
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      async fetchSchoolLocation(schoolId) {
        this.loading = true;
        return schoolsLocationsService.index(schoolId)
        .then(response => {
            this.locations = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
              this.loading = false;
        });
      },
      async showCampaignModal(id) {
        this.showModal({
          component: CampaignTeacherModal,
            data: {
              stored: {
                id,
                teacher_id: this.filters.teacherId || id,
              },
          },
          options: {
            title: this.$t('CAMPAIGN'),
            fullscreen: true,
            onSave: (
              form,
              error,
            ) => campaignsService.save(form)
            .then(async () => {
              this.hideModal({});
              await this.fetchTeachers(1);
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            }),
          },
        });
      },

      async showClassesModal(item) {
        this.showModal({
          component: SchoolTeacherModal,
          data: {
            stored: {
              id: item.id,
              teacher_id: item.teacher.id,
            },
          },
          options: {
            title: this.$t('CHANGE_CLASSES'),
            onSave: (
              form,
              error,
            ) => teachersSchoolsService.save(form)
            .then(async () => {
              this.hideModal({});
              await this.fetchTeachers(this.pagination.page);
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            }),
          },
        });
      },

      deleteSelectedSchools() {
        this.resetItems();
        this.codes = [];
        this.school = {};
      },

      resetItems() {
        this.totalItems = 0;
        this.items = [];
      },

      fetchCodes(schoolId) {
        this.loading = true;
        return schoolsCodesService.index(schoolId)
        .then(response => {
            this.codes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async searchSchools(val) {
        this.filters.searchSchools = val;
        await this.fetchSchools();
      },

      async fetchSchools() {
        this.loading = true;
        return schoolsService.index({
          filters: {
            search: this.filters.searchSchools,
          },
        })
        .then(response => {
            this.resetTeacher();
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },
      resetTeacher() {
        this.totalItems = 0;
        this.items = [];
      },
      async fetchTeachers(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return schoolsService.teachers(this.filters.schoolId, {
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
            console.log(response.data.data);
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            console.log('finally');
            this.loading = false;
          });
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
          await this.fetchSchool(id);
          await this.fetchSchoolLocation(id);
          await this.fetchCodes(id);
        } else {
          this.filters.schoolId = 0;
        }
      },

      fetchSchool(id) {
        this.loading = true;
        return schoolsService.get(id)
        .then(response => {
            this.school = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

     setToBox(teacherId) {
       this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return teachersService.box(teacherId)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('BOXED') });
                this.fetchTeachers(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
     },

      deleteSelectedTeacher() {
        this.teacher = {};
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },

    },
    async created() {
      if (this.$route.query.id) {
        await this.fetchSchoolsIfExist(this.$route.query.id);
        await this.searchSchools(this.school.name);

        this.searchSchool = parseInt(this.$route.query.id, 10);
        this.reloadAutocomplete += 1;

        if (this.$route.query.schoolCodeId) {
          const returnSchoolCodeIds = this.$route.query.schoolCodeId.split(',');
          returnSchoolCodeIds.forEach((code) => {
            this.schoolCodeId.push(parseInt(code, 10));
          });
        }

        if (this.$route.query.subjectId) {
          const returnSubjectIds = this.$route.query.subjectId.split(',');
          returnSubjectIds.forEach((subject) => {
            this.subjectId.push(parseInt(subject, 10));
          });
        }
      }
    },
    watch: {
      'filters.schoolId': {
        immediate: true,
        deep: true,
        handler(oldVal, newVal) {
          if (oldVal && newVal && oldVal !== newVal) {
            this.fetchTeachers(1);
          }
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchTeachers(1);
          }
        },
      },
    },
  };
</script>
<style lang="scss">
.red-background {
  background-color: rgba(255, 0, 0, 0.3);
}
</style>
